/**
 * Typography style mappings.
 *
 * @internal Used by Typography atom only.
 */

import type { TypographyColor, TypographyVariant, TypographyWeight } from './Typography.types';

export const variantStyles: Record<TypographyVariant, string> = {
  // --- HEADINGS (Archivo) ---
  // The image specifies 100% leading (leading-none) and negative spacing.
  h1: 'font-heading text-2xl sm:text-4xl font-bold tracking-tighter leading-none',
  h2: 'font-heading text-xl sm:text-2xl font-semibold tracking-tighter leading-tight',
  h3: 'font-heading text-lg sm:text-xl font-semibold tracking-tight leading-tight',

  // Mid-sized headings
  h4: 'font-heading text-base sm:text-lg font-semibold tracking-tight leading-snug',
  h5: 'font-heading text-sm sm:text-base font-semibold leading-snug',
  h6: 'font-heading text-xs sm:text-sm font-semibold uppercase tracking-wider leading-normal',

  // --- BODY TEXT (Inter) ---
  // Inter Medium is specified. 'font-medium' matches the guideline better than 'font-normal'.
  'body-lg': 'font-body text-base sm:text-lg leading-relaxed font-medium',
  
  // Standard body
  'body-md': 'font-body text-sm sm:text-base leading-normal font-medium',
  
  // Small body
  'body-sm': 'font-body text-xs sm:text-sm leading-normal font-normal',
  'body-xs': 'font-body text-[10px] sm:text-xs leading-tight font-normal',

  // --- SPECIALTY ---
  caption: 'font-body text-[10px] sm:text-xs font-bold uppercase tracking-widest leading-none',
};




export const weightStyles: Record<TypographyWeight, string> = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
} as const;

export const colorStyles: Record<TypographyColor, string> = {
  primary: 'text-dark-invirtus',
  secondary: 'text-grey',
  muted: 'text-grey-muted',
  white: 'text-white',
  error: 'text-red',
  inherit: 'text-inherit',
} as const;
